import { createAction } from '@reduxjs/toolkit'
import { AllowedRefs } from 'lib/websocket-notify'
import { SerializedErrorType } from './reducer'

export const queued = createAction<{ type: string; refs: AllowedRefs[] }>('multiget/queued')
export const requested = createAction<{ type: string; refs: AllowedRefs[] }>('multiget/requested')
export const fulfilled = createAction<{ type: string; objects: Record<string, unknown> }>('multiget/fulfilled')
export const rejected = createAction<{ type: string; errors: Record<string, SerializedErrorType> }>('multiget/rejected')
export const markStale = createAction<{ type: string; ref: AllowedRefs }>('multiget/markStale')
export const evict = createAction<{ type: string; cutoff: number }>('multiget/evict')
